import type { ComponentProps } from "react";
import { AdminDataNotice } from "@/components/admin/data-notice";
import { OutboxView } from "@/components/admin/prospection/outbox-view";
import { useAdminView } from "@shared/client/admin-view";
import { usePageTitle } from "@shared/client/view";

export default function ProspectionOutboxPage() {
  usePageTitle("Envois — Prospection — Administration Hune");
  const { data, error } = useAdminView<ComponentProps<typeof OutboxView>>("/api/views/admin/prospection/outbox");
  if (error) return <AdminDataNotice error={error} />;
  if (!data) return null;
  return <OutboxView {...data} />;
}
